@if (this.view === AppView.DESKTOP) {
    <app-fipy-start-page></app-fipy-start-page>
} @else if (this.view === AppView.MOBILE) {
    <app-fipy-start-page-mobile></app-fipy-start-page-mobile>
}
